import { api } from './_api-client';

export interface Meta {
  description: string;
  amount: number;
  name: string;
  watermark: string;
}

export interface BasePrice extends Meta {
  amount: number;
  currency: number;
  description: string;
  type: number;
  name: string;
  watermark: string;
}

export interface PaymentPrice extends BasePrice {
  type: PaymentType;
}

export interface SubscriptionPrice extends BasePrice {
  planId: string;
  image: string;
  storageLimit: number;
  type: SubscriptionType;
}

export interface Prices {
  productPrices: PaymentPrice[];
  subscriptionPrices: SubscriptionPrice[];
}

export enum PaymentType {
  Free,
  Basic,
  Hd,
  Fhd,
  Uhd,
}

export enum SubscriptionType {
  Hd,
  Fhd,
  Uhd,
  Pro,
}

export interface Payment {
  status: PaymentStatus;
  type: PaymentType;
  price: Meta;
}

export enum PaymentStatus {
  Pending,
  Created,
  Completed,
  Error,
}

export interface Subscription {
  type: SubscriptionType;
  price: Meta;
}

export interface PaymentSession {
  url: string;
}

export enum SubscriptionStatus {
  Created,
  Activated,
  Expired,
  Cancelled,
  Suspended,
  Failed,
}

/* S E R V I C E */

export const getPaymentPricing = () => {
  return api.get<Prices>(`/Payment/GetPrices`);
};

export const cancelAllSubscriptions = () => {
  return api.delete(`/Payment/CancelAllSubscriptions`);
};

export const createSubscriptionSession = (type: SubscriptionType) => {
  return api.post<PaymentSession>(`/Payment/CreateSubscriptionSession?type=${type}`);
};

export const upgradeSubscription = (type: SubscriptionType) => {
  return api.post(`/Payment/UpgradeSubscription?type=${type}`);
};

export const createPaymentSession = (finalCutId: FinalcutId, paymentPlan: number) => {
  return api.post<PaymentSession>(`/Payment/CreatePaymentSession?finalCutId=${finalCutId}&finalCutType=${paymentPlan}`);
};

export const upgradeResolution = (finalCutId: FinalcutId, paymentPlan: number) => {
  return api.post(`/Payment/UpgradeFinalCutResolution?finalCutId=${finalCutId}&type=${paymentPlan}`);
};
